import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SwatchBook, Menu, X } from 'lucide-react';

const MainNavbar = ({ activePage = null }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const getNavLinkClass = (page) => {
    return activePage === page 
      ? "text-orange-500 font-medium" 
      : "text-gray-700 hover:text-black";
  };

  return (
    <nav className="flex items-center justify-between p-6 sticky top-0 bg-white/95 backdrop-blur-sm z-50 shadow-sm">
      <div className="text-2xl font-bold text-black">
        {/* Logo with proper router Link */}
        <Link to="/" className="flex items-center">
          < SwatchBook className="w-8 h-8 mr-2 text-orange-500" />
          <span>dessino.ai</span>
        </Link>
      </div>

      {/* Mobile menu button */}
      <div className="md:hidden">
        <button 
          onClick={toggleMenu}
          className="text-gray-700 hover:text-black focus:outline-none"
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
        >
          {isMenuOpen ? (
            <X className="w-6 h-6" />
          ) : (
            <Menu className="w-6 h-6" />
          )}
        </button>
      </div>

      {/* Desktop menu */}
      <div className="hidden md:flex md:items-center md:space-x-6">
      <Link to="/demo" className={getNavLinkClass('demo')}>Examples</Link>
        <Link to="/features" className={getNavLinkClass('features')}>Features</Link>
        <Link to="/pricing" className={getNavLinkClass('pricing')}>Pricing</Link>
        <Link to="/contact" className={getNavLinkClass('contact')}>Contact</Link>
        <div className="pl-6 border-l border-gray-200">
          <Link to="/login" className="mr-4 text-gray-700 hover:text-black">Login</Link>
          <Link to="/signup" className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800 transition-colors">Sign Up</Link>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="absolute top-full left-0 right-0 bg-white shadow-md md:hidden z-20">
          <div className="flex flex-col p-4 space-y-4">
          <Link 
              to="/demo" 
              className={getNavLinkClass('demo')}
              onClick={() => setIsMenuOpen(false)}
            >
              Examples
            </Link>
            <Link 
              to="/features" 
              className={getNavLinkClass('features')}
              onClick={() => setIsMenuOpen(false)}
            >
              Features
            </Link>
            <Link 
              to="/pricing" 
              className={getNavLinkClass('pricing')}
              onClick={() => setIsMenuOpen(false)}
            >
              Pricing
            </Link>
            <Link 
              to="/contact" 
              className={getNavLinkClass('contact')}
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </Link>
            <div className="pt-4 border-t border-gray-200 flex flex-col space-y-3">
              <Link 
                to="/login" 
                className="text-gray-700 hover:text-black"
                onClick={() => setIsMenuOpen(false)}
              >
                Login
              </Link>
              <Link 
                to="/signup" 
                className="px-4 py-2 bg-black text-white rounded-md hover:bg-gray-800 transition-colors text-center"
                onClick={() => setIsMenuOpen(false)}
              >
                Sign Up
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default MainNavbar;